export default __webpack_public_path__ + "static/media/VDMDemoTranSmall.0da1b0f5.png";